import React, { useState } from "react";
import NgoLayout from "../../../../layouts/Ngo/NgoLayout";
import '../../../../assets/css/Ngo/controlpanelCSS/NgoCaseVerification.css';
import {
   Eye,
  CheckCircle,
  XCircle,
  Clock,
  FileText,
  User,
  DollarSign,
  Calendar,
  Download,
  Search,
  BookOpen,
  Shirt,
  CreditCard,
  X
} from "lucide-react";

const NgoAllCases = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const [selectedCase, setSelectedCase] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  const itemsPerPage = 6;

  // All cases data - Student Donation Requests
  const allCasesData = {
    pending: [
      { 
        id: 1, 
        studentName: 'Ayesha Khan', 
        rollNumber: 'STD-2024-001', 
        requestType: 'School Fee',
        amount: 'PKR 45,000',
        submittedDate: '2024-01-15',
        status: 'Pending Verification',
        semester: 'Spring 2024',
        institution: 'Punjab University',
        department: 'Computer Science',
        contactNumber: '+92 300 1234567',
        email: 'ayesha.khan@email.com',
        cnicNumber: '35202-1234567-8',
        address: 'House 123, Street 5, Model Town, Lahore',
        reason: 'Need financial assistance for semester fee payment. Family income is not sufficient to cover educational expenses.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-15', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'verified', uploadDate: '2024-01-15', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'verified', uploadDate: '2024-01-15', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'pending', uploadDate: '2024-01-15', url: 'address-proof.pdf' },
          { name: 'Fee Challan', status: 'verified', uploadDate: '2024-01-15', url: 'fee-challan.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-15', url: 'case-docs.pdf' }
        ]
      },
      { 
        id: 2, 
        studentName: 'Ali Hassan', 
        rollNumber: 'STD-2024-002', 
        requestType: 'Books',
        amount: 'PKR 25,000',
        submittedDate: '2024-01-14',
        status: 'Pending Verification',
        semester: 'Fall 2024',
        institution: 'NUST Islamabad',
        department: 'Electrical Engineering',
        contactNumber: '+92 301 7654321',
        email: 'ali.hassan@email.com',
        cnicNumber: '61101-9876543-2',
        address: 'Flat 45, Block B, G-11, Islamabad',
        reason: 'Required engineering textbooks are very expensive. Need support to purchase course materials.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-14', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'verified', uploadDate: '2024-01-14', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'verified', uploadDate: '2024-01-14', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'verified', uploadDate: '2024-01-14', url: 'address-proof.pdf' },
          { name: 'Book List', status: 'verified', uploadDate: '2024-01-14', url: 'book-list.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-14', url: 'case-docs.pdf' }
        ]
      },
      { 
        id: 3, 
        studentName: 'Fatima Zahra', 
        rollNumber: 'STD-2024-003', 
        requestType: 'Uniform',
        amount: 'PKR 15,000',
        submittedDate: '2024-01-13',
        status: 'Pending Verification',
        semester: 'Spring 2024',
        institution: 'Lahore College',
        department: 'Medical Technology',
        contactNumber: '+92 302 9876543',
        email: 'fatima.zahra@email.com',
        cnicNumber: '35202-5555444-3',
        address: 'House 67, Block C, Johar Town, Lahore',
        reason: 'Medical lab uniform and safety equipment required for practical sessions.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-13', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'pending', uploadDate: '2024-01-13', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'verified', uploadDate: '2024-01-13', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'verified', uploadDate: '2024-01-13', url: 'address-proof.pdf' },
          { name: 'Uniform Requirement', status: 'verified', uploadDate: '2024-01-13', url: 'uniform-req.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-13', url: 'case-docs.pdf' }
        ]
      },
      { 
        id: 4, 
        studentName: 'Ahmed Raza', 
        rollNumber: 'STD-2024-004', 
        requestType: 'School Fee',
        amount: 'PKR 50,000',
        submittedDate: '2024-01-12',
        status: 'Pending Verification',
        semester: 'Fall 2024',
        institution: 'IBA Karachi',
        department: 'Business Administration',
        contactNumber: '+92 303 5551234',
        email: 'ahmed.raza@email.com',
        cnicNumber: '42101-7778889-1',
        address: 'House 89, DHA Phase 5, Karachi',
        reason: 'Father lost job recently. Need urgent support for semester fee to continue studies.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-12', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'verified', uploadDate: '2024-01-12', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'pending', uploadDate: '2024-01-12', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'verified', uploadDate: '2024-01-12', url: 'address-proof.pdf' },
          { name: 'Fee Challan', status: 'verified', uploadDate: '2024-01-12', url: 'fee-challan.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-12', url: 'case-docs.pdf' }
        ]
      },
      { 
        id: 5, 
        studentName: 'Sara Malik', 
        rollNumber: 'STD-2024-005', 
        requestType: 'Books',
        amount: 'PKR 20,000',
        submittedDate: '2024-01-11',
        status: 'Pending Verification',
        semester: 'Spring 2024',
        institution: 'LUMS Lahore',
        department: 'Economics',
        contactNumber: '+92 304 7778888',
        email: 'sara.malik@email.com',
        cnicNumber: '35202-3332221-5',
        address: 'Apartment 12, Gulberg III, Lahore',
        reason: 'Need economics reference books for final year research project.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-11', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'verified', uploadDate: '2024-01-11', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'verified', uploadDate: '2024-01-11', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'verified', uploadDate: '2024-01-11', url: 'address-proof.pdf' },
          { name: 'Book List', status: 'verified', uploadDate: '2024-01-11', url: 'book-list.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-11', url: 'case-docs.pdf' }
        ]
      },
      { 
        id: 6, 
        studentName: 'Bilal Ahmed', 
        rollNumber: 'STD-2024-006', 
        requestType: 'Uniform',
        amount: 'PKR 12,000',
        submittedDate: '2024-01-10',
        status: 'Pending Verification',
        semester: 'Fall 2024',
        institution: 'UET Taxila',
        department: 'Mechanical Engineering',
        contactNumber: '+92 305 4443332',
        email: 'bilal.ahmed@email.com',
        cnicNumber: '37405-6667778-9',
        address: 'House 34, Street 12, Satellite Town, Rawalpindi',
        reason: 'Workshop uniform and safety boots required for engineering lab work.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-10', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'verified', uploadDate: '2024-01-10', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'verified', uploadDate: '2024-01-10', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'pending', uploadDate: '2024-01-10', url: 'address-proof.pdf' },
          { name: 'Uniform Requirement', status: 'verified', uploadDate: '2024-01-10', url: 'uniform-req.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-10', url: 'case-docs.pdf' }
        ]
      }
    ],
    approved: [
      { 
        id: 7, 
        studentName: 'Zainab Ali', 
        rollNumber: 'STD-2024-007', 
        requestType: 'School Fee',
        amount: 'PKR 40,000',
        submittedDate: '2024-01-05',
        approvedDate: '2024-01-08',
        status: 'Approved',
        semester: 'Spring 2024',
        institution: 'Karachi University',
        department: 'Pharmacy',
        contactNumber: '+92 306 9998887',
        email: 'zainab.ali@email.com',
        cnicNumber: '42101-1112223-4',
        address: 'House 56, Gulshan-e-Iqbal, Karachi',
        reason: 'Approved for semester fee assistance. Family income insufficient.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-05', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'verified', uploadDate: '2024-01-05', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'verified', uploadDate: '2024-01-05', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'verified', uploadDate: '2024-01-05', url: 'address-proof.pdf' },
          { name: 'Fee Challan', status: 'verified', uploadDate: '2024-01-05', url: 'fee-challan.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-05', url: 'case-docs.pdf' }
        ]
      },
      { 
        id: 8, 
        studentName: 'Hassan Mehmood', 
        rollNumber: 'STD-2024-008', 
        requestType: 'Books',
        amount: 'PKR 18,000',
        submittedDate: '2024-01-04',
        approvedDate: '2024-01-07',
        status: 'Approved',
        semester: 'Fall 2024',
        institution: 'FAST Islamabad',
        department: 'Software Engineering',
        contactNumber: '+92 307 2221113',
        email: 'hassan.mehmood@email.com',
        cnicNumber: '61101-4445556-7',
        address: 'Flat 23, Bahria Town, Islamabad',
        reason: 'Programming and software engineering books approved.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-04', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'verified', uploadDate: '2024-01-04', url: 'cnic-back.pdf' },
          { name: 'Student Card', status: 'verified', uploadDate: '2024-01-04', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'verified', uploadDate: '2024-01-04', url: 'address-proof.pdf' },
          { name: 'Book List', status: 'verified', uploadDate: '2024-01-04', url: 'book-list.pdf' },
          { name: 'Case Documents', status: 'verified', uploadDate: '2024-01-04', url: 'case-docs.pdf' }
        ]
      }
    ],
    rejected: [
      { 
        id: 9, 
        studentName: 'Usman Khan', 
        rollNumber: 'STD-2024-009', 
        requestType: 'School Fee',
        amount: 'PKR 55,000',
        submittedDate: '2024-01-03',
        rejectedDate: '2024-01-06',
        status: 'Rejected',
        semester: 'Spring 2024',
        institution: 'Private University',
        department: 'MBA',
        contactNumber: '+92 310 7778889',
        email: 'usman.khan@email.com',
        cnicNumber: '35202-9990001-2',
        address: 'House 90, DHA, Lahore',
        rejectionReason: 'Incomplete documentation. CNIC back copy and address proof not submitted. Student card verification failed.',
        reason: 'Request was rejected due to missing required documents.',
        documents: [
          { name: 'CNIC Front', status: 'verified', uploadDate: '2024-01-03', url: 'cnic-front.pdf' },
          { name: 'CNIC Back', status: 'missing', uploadDate: null, url: null },
          { name: 'Student Card', status: 'rejected', uploadDate: '2024-01-03', url: 'student-card.pdf' },
          { name: 'Address Proof', status: 'missing', uploadDate: null, url: null },
          { name: 'Fee Challan', status: 'verified', uploadDate: '2024-01-03', url: 'fee-challan.pdf' },
          { name: 'Case Documents', status: 'missing', uploadDate: null, url: null }
        ]
      }
    ]
  };

  // Get current cases based on active tab
  const getCurrentCases = () => {
    const cases = allCasesData[activeTab] || [];
    
    // Filter by search term
    if (searchTerm) {
      return cases.filter(c => 
        c.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.rollNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.requestType.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    return cases;
  };

  const currentCases = getCurrentCases();
  
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginatedCases = currentCases.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(currentCases.length / itemsPerPage);

  // Handle view details
  const handleViewDetails = (caseItem) => {
    setSelectedCase(caseItem);
    setShowModal(true);
  };

  // Handle close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setTimeout(() => setSelectedCase(null), 300);
  };

  // Handle document view
  const handleViewDocument = (doc) => {
    setSelectedDocument(doc);
    setShowDocumentModal(true);
  };

  // Handle close document modal
  const handleCloseDocumentModal = () => {
    setShowDocumentModal(false);
    setTimeout(() => setSelectedDocument(null), 300);
  };

  // Handle approve request
  const handleApprove = () => {
    if (selectedCase) {
      alert(`Request Approved!\n\nStudent: ${selectedCase.studentName}\nRoll Number: ${selectedCase.rollNumber}\nAmount: ${selectedCase.amount}\n\nThis case has been approved successfully.`);
      handleCloseModal();
    }
  };

  // Handle reject request
  const handleReject = () => {
    setShowRejectModal(true);
  };

  // Handle submit rejection
  const handleSubmitRejection = () => {
    if (!rejectionReason.trim()) {
      alert('Please provide a reason for rejection');
      return;
    }
    
    if (selectedCase) {
      alert(`Request Rejected!\n\nStudent: ${selectedCase.studentName}\nRoll Number: ${selectedCase.rollNumber}\n\nRejection Reason:\n${rejectionReason}\n\nThe student will be notified via email.`);
      setShowRejectModal(false);
      setRejectionReason('');
      handleCloseModal();
    }
  };

  // Handle export report
  const handleExportReport = () => {
    const cases = getCurrentCases();
    
    if (cases.length === 0) {
      alert('No data to export');
      return;
    }

    // Create CSV content
    let csvContent = "Student Name,Roll Number,Request Type,Amount,Status,Submitted Date,Institution,Department\n";
    
    cases.forEach(caseItem => {
      csvContent += `"${caseItem.studentName}","${caseItem.rollNumber}","${caseItem.requestType}","${caseItem.amount}","${caseItem.status}","${caseItem.submittedDate}","${caseItem.institution}","${caseItem.department}"\n`;
    });

    // Create blob and download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `student_requests_${activeTab}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Get request type icon
  const getRequestIcon = (type) => {
    switch(type) {
      case 'School Fee':
        return <CreditCard size={16} />;
      case 'Books':
        return <BookOpen size={16} />;
      case 'Uniform':
        return <Shirt size={16} />;
      default:
        return <FileText size={16} />;
    }
  };

  // Get request type badge
  const getRequestBadge = (type) => {
    let className = 'request-badge ';
    switch(type) {
      case 'School Fee':
        className += 'fee';
        break;
      case 'Books':
        className += 'books';
        break;
      case 'Uniform':
        className += 'uniform';
        break;
      default:
        className += 'other';
    }
    
    return (
      <span className={className}>
        {getRequestIcon(type)}
        {type}
      </span>
    );
  };

  // Get status badge
  const getStatusBadge = (status) => {
    switch(status) {
      case 'Pending Verification':
        return <span className="status-badge pending"><Clock size={14} /> Pending</span>;
      case 'Approved':
        return <span className="status-badge approved"><CheckCircle size={14} /> Approved</span>;
      case 'Rejected':
        return <span className="status-badge rejected"><XCircle size={14} /> Rejected</span>;
      default:
        return <span className="status-badge">{status}</span>;
    }
  };

  // Get document status badge
  const getDocStatusBadge = (status) => {
    switch(status) {
      case 'verified':
        return <span className="doc-status verified">✓ Verified</span>;
      case 'pending':
        return <span className="doc-status pending">⏳ Pending</span>;
      case 'rejected':
        return <span className="doc-status rejected">✕ Rejected</span>;
      case 'missing':
        return <span className="doc-status missing">! Missing</span>;
      default:
        return <span className="doc-status">Unknown</span>;
    }
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Reset page when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    setSearchTerm('');
  };

  return (
    <NgoLayout>
      <div className="nac-container">
        <div className="nac-wrapper">
          {/* Header */}
          <div className="nac-header">
            <div>
              <h1 className="nac-title">Student Donation Requests</h1>
              <p className="nac-subtitle">Manage all student fee, books, and uniform donation requests</p>
            </div>
            <div className="nac-header-actions">
              <button className="nac-btn-export" onClick={handleExportReport}>
                <Download size={18} />
                Export Report
              </button>
            </div>
          </div>

          {/* Tabs and Search */}
          <div className="nac-controls">
            <div className="nac-tabs">
              <button 
                className={`nac-tab ${activeTab === 'pending' ? 'active' : ''}`}
                onClick={() => handleTabChange('pending')}
              >
                <Clock size={18} />
                Pending Verification
                <span className="nac-tab-count">{allCasesData.pending.length}</span>
              </button>
              <button 
                className={`nac-tab ${activeTab === 'approved' ? 'active' : ''}`}
                onClick={() => handleTabChange('approved')}
              >
                <CheckCircle size={18} />
                Approved Requests
                <span className="nac-tab-count">{allCasesData.approved.length}</span>
              </button>
              <button 
                className={`nac-tab ${activeTab === 'rejected' ? 'active' : ''}`}
                onClick={() => handleTabChange('rejected')}
              >
                <XCircle size={18} />
                Rejected Requests
                <span className="nac-tab-count">{allCasesData.rejected.length}</span>
              </button>
            </div>

            <div className="nac-search-wrapper">
              <Search size={18} className="nac-search-icon" />
              <input 
                type="text"
                placeholder="Search by name, roll number, or request type..."
                className="nac-search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* Table Card */}
          <div className="nac-card">
            <div className="nac-table-wrapper">
              <table className="nac-table">
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Request Type</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Submitted</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedCases.length > 0 ? (
                    paginatedCases.map((caseItem) => (
                      <tr key={caseItem.id}>
                        <td>
                          <div className="nac-student-cell">
                            <div className="nac-avatar">
                              {caseItem.studentName.charAt(0)}
                            </div>
                            <span className="nac-student-name">{caseItem.studentName}</span>
                          </div>
                        </td>
                        <td>{getRequestBadge(caseItem.requestType)}</td>
                        <td className="nac-amount">{caseItem.amount}</td>
                        <td>{getStatusBadge(caseItem.status)}</td>
                        <td className="nac-date">{caseItem.submittedDate}</td>
                        <td>
                          <button 
                            className="nac-btn-view"
                            onClick={() => handleViewDetails(caseItem)}
                          >
                            <Eye size={16} />
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="nac-no-data">
                        No requests found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {currentCases.length > 0 && (
              <div className="nac-pagination">
                <div className="nac-pagination-info">
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, currentCases.length)} of {currentCases.length} requests
                </div>
                <div className="nac-pagination-buttons">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`nac-pagination-btn ${currentPage === 1 ? 'disabled' : ''}`}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handlePageChange(index + 1)}
                      className={`nac-pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`nac-pagination-btn ${currentPage === totalPages ? 'disabled' : ''}`}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Main Details Modal */}
        {showModal && selectedCase && (
          <div className={`nac-modal-overlay ${showModal ? 'show' : ''}`} onClick={handleCloseModal}>
            <div className={`nac-modal ${showModal ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
              {/* Modal Header */}
              <div className="nac-modal-header">
                <div>
                  <h2 className="nac-modal-title">Student Request Details</h2>
                  <p className="nac-modal-subtitle">{selectedCase.rollNumber}</p>
                </div>
                <button onClick={handleCloseModal} className="nac-modal-close">
                  ×
                </button>
              </div>

              {/* Modal Content */}
              <div className="nac-modal-content">
                <div className="nac-modal-grid">
                  {/* Left Column */}
                  <div className="nac-modal-left">
                    {/* Student Information */}
                    <div className="nac-section">
                      <h3 className="nac-section-title">
                        <User size={18} />
                        Student Information
                      </h3>
                      <div className="nac-info-grid">
                        <div className="nac-info-item">
                          <span className="nac-info-label">Full Name</span>
                          <span className="nac-info-value">{selectedCase.studentName}</span>
                        </div>
                        <div className="nac-info-item">
                          <span className="nac-info-label">Roll Number</span>
                          <span className="nac-info-value">{selectedCase.rollNumber}</span>
                        </div>
                        <div className="nac-info-item">
                          <span className="nac-info-label">CNIC Number</span>
                          <span className="nac-info-value">{selectedCase.cnicNumber}</span>
                        </div>
                        <div className="nac-info-item">
                          <span className="nac-info-label">Contact Number</span>
                          <span className="nac-info-value">{selectedCase.contactNumber}</span>
                        </div>
                        <div className="nac-info-item full-width">
                          <span className="nac-info-label">Email Address</span>
                          <span className="nac-info-value">{selectedCase.email}</span>
                        </div>
                        <div className="nac-info-item full-width">
                          <span className="nac-info-label">Address</span>
                          <span className="nac-info-value">{selectedCase.address}</span>
                        </div>
                      </div>
                    </div>

                    {/* Academic Information */}
                    <div className="nac-section">
                      <h3 className="nac-section-title">
                        <BookOpen size={18} />
                        Academic Information
                      </h3>
                      <div className="nac-info-grid">
                        <div className="nac-info-item">
                          <span className="nac-info-label">Institution</span>
                          <span className="nac-info-value">{selectedCase.institution}</span>
                        </div>
                        <div className="nac-info-item">
                          <span className="nac-info-label">Department</span>
                          <span className="nac-info-value">{selectedCase.department}</span>
                        </div>
                        <div className="nac-info-item full-width">
                          <span className="nac-info-label">Semester</span>
                          <span className="nac-info-value">{selectedCase.semester}</span>
                        </div>
                      </div>
                    </div>

                    {/* Request Reason */}
                    <div className="nac-section">
                      <h3 className="nac-section-title">
                        <FileText size={18} />
                        Request Reason
                      </h3>
                      <p className="nac-summary-text">{selectedCase.reason}</p>
                    </div>

                    {/* Submitted Documents */}
                    <div className="nac-section">
                      <h3 className="nac-section-title">
                        <FileText size={18} />
                        Submitted Documents
                      </h3>
                      <div className="nac-documents-grid">
                        {selectedCase.documents.map((doc, index) => (
                          <div key={index} className="nac-document-card" onClick={() => handleViewDocument(doc)} style={{cursor: 'pointer'}}>
                            <div className="nac-doc-header">
                              <FileText size={16} />
                              <span className="nac-doc-name">{doc.name}</span>
                            </div>
                            <div className="nac-doc-footer">
                              {getDocStatusBadge(doc.status)}
                              {doc.uploadDate && (
                                <span className="nac-doc-date">{doc.uploadDate}</span>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="nac-modal-right">
                    {/* Request Details */}
                    <div className="nac-section">
                      <h3 className="nac-section-title">
                        <DollarSign size={18} />
                        Request Details
                      </h3>
                      <div className="nac-detail-card">
                        <div className="nac-detail-row">
                          <span className="nac-detail-label">Request Type</span>
                          {getRequestBadge(selectedCase.requestType)}
                        </div>
                        <div className="nac-detail-row">
                          <span className="nac-detail-label">Requested Amount</span>
                          <span className="nac-detail-value amount">{selectedCase.amount}</span>
                        </div>
                        <div className="nac-detail-row">
                          <span className="nac-detail-label">Current Status</span>
                          {getStatusBadge(selectedCase.status)}
                        </div>
                      </div>
                    </div>

                    {/* Timeline */}
                    <div className="nac-section">
                      <h3 className="nac-section-title">
                        <Calendar size={18} />
                        Request Timeline
                      </h3>
                      <div className="nac-timeline">
                        <div className="nac-timeline-item">
                          <div className="nac-timeline-dot"></div>
                          <div>
                            <div className="nac-timeline-label">Request Submitted</div>
                            <div className="nac-timeline-date">{selectedCase.submittedDate}</div>
                          </div>
                        </div>
                        {selectedCase.approvedDate && (
                          <div className="nac-timeline-item">
                            <div className="nac-timeline-dot approved"></div>
                            <div>
                              <div className="nac-timeline-label">Request Approved</div>
                              <div className="nac-timeline-date">{selectedCase.approvedDate}</div>
                            </div>
                          </div>
                        )}
                        {selectedCase.rejectedDate && (
                          <div className="nac-timeline-item">
                            <div className="nac-timeline-dot rejected"></div>
                            <div>
                              <div className="nac-timeline-label">Request Rejected</div>
                              <div className="nac-timeline-date">{selectedCase.rejectedDate}</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Rejection Reason (if rejected) */}
                    {selectedCase.rejectionReason && (
                      <div className="nac-section">
                        <h3 className="nac-section-title">
                          <XCircle size={18} />
                          Rejection Reason
                        </h3>
                        <div className="nac-rejection-box">
                          {selectedCase.rejectionReason}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Modal Footer */}
              <div className="nac-modal-footer">
                <button className="nac-btn-close" onClick={handleCloseModal}>
                  Close Details
                </button>
                {selectedCase.status === 'Pending Verification' && (
                  <>
                    <button className="nac-btn-approve" onClick={handleApprove}>
                      <CheckCircle size={18} />
                      Approve Request
                    </button>
                    <button className="nac-btn-reject" onClick={handleReject}>
                      <XCircle size={18} />
                      Reject Request
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Document View Modal */}
        {showDocumentModal && selectedDocument && (
          <div className={`nac-modal-overlay ${showDocumentModal ? 'show' : ''}`} onClick={handleCloseDocumentModal}>
            <div className={`nac-modal nac-doc-modal ${showDocumentModal ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
              <div className="nac-modal-header">
                <div>
                  <h2 className="nac-modal-title">{selectedDocument.name}</h2>
                  <p className="nac-modal-subtitle">
                    Status: {getDocStatusBadge(selectedDocument.status)}
                    {selectedDocument.uploadDate && ` • Uploaded: ${selectedDocument.uploadDate}`}
                  </p>
                </div>
                <button onClick={handleCloseDocumentModal} className="nac-modal-close">
                  ×
                </button>
              </div>
              <div className="nac-modal-content">
                <div style={{
                  background: '#f5f5f5',
                  border: '2px dashed #ddd',
                  borderRadius: '8px',
                  padding: '60px 20px',
                  textAlign: 'center',
                  minHeight: '400px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <FileText size={80} color="#999" />
                  <h3 style={{marginTop: '20px', color: '#666'}}>Document Preview</h3>
                  <p style={{color: '#999', marginTop: '10px'}}>
                    {selectedDocument.url ? selectedDocument.url : 'Document not available'}
                  </p>
                  <p style={{color: '#999', fontSize: '14px', marginTop: '5px'}}>
                    In production, this would display the actual document content
                  </p>
                </div>
              </div>
              <div className="nac-modal-footer">
                <button className="nac-btn-close" onClick={handleCloseDocumentModal}>
                  Close
                </button>
                {selectedDocument.url && (
                  <button className="nac-btn-export" style={{marginLeft: '10px'}}>
                    <Download size={18} />
                    Download Document
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Reject Reason Modal */}
        {showRejectModal && (
          <div className={`nac-modal-overlay ${showRejectModal ? 'show' : ''}`} onClick={() => setShowRejectModal(false)}>
            <div className={`nac-modal nac-reject-modal ${showRejectModal ? 'show' : ''}`} onClick={(e) => e.stopPropagation()} style={{maxWidth: '500px'}}>
              <div className="nac-modal-header">
                <div>
                  <h2 className="nac-modal-title">Reject Request</h2>
                  <p className="nac-modal-subtitle">Please provide a reason for rejection</p>
                </div>
                <button onClick={() => setShowRejectModal(false)} className="nac-modal-close">
                  ×
                </button>
              </div>
              <div className="nac-modal-content">
                <textarea
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  placeholder="Enter detailed reason for rejection..."
                  style={{
                    width: '100%',
                    minHeight: '150px',
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical'
                  }}
                />
              </div>
              <div className="nac-modal-footer">
                <button className="nac-btn-close" onClick={() => setShowRejectModal(false)}>
                  Cancel
                </button>
                <button className="nac-btn-reject" onClick={handleSubmitRejection}>
                  <XCircle size={18} />
                  Submit Rejection
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </NgoLayout>
  );
};

export default NgoAllCases;